import type { PhieuNganHangGiayBaoCo } from '@/types/schemas/giay-bao-co.type';
import type { TableSelectedCell } from '@/components/custom/erp';
import { useTableRows } from '@/components/custom/erp';

export type SelectedCellInfo = TableSelectedCell;

export interface BankFeeRow extends PhieuNganHangGiayBaoCo {
  uuid: string;
  ma_cpnh_data?:
    | ({
        ma_thue_data?: {
          thue_suat?: string | number;
        };
      } & NonNullable<PhieuNganHangGiayBaoCo['ma_cpnh_data']>)
    | null;
}

type BankFeeRowInput = Omit<PhieuNganHangGiayBaoCo, 'uuid'> & { uuid?: string | null };

const normalizeInitialRows = (rows: BankFeeRowInput[] = []): BankFeeRow[] =>
  rows.map((row, index) => ({
    ...row,
    uuid: row.uuid && row.uuid !== '' ? row.uuid : `temp-${Date.now()}-${index}`
  })) as BankFeeRow[];

export function useBankFeeRows(initialRows: BankFeeRowInput[] = []) {
  const {
    rows,
    setRows,
    selectedRowUuid,
    setSelectedRowUuid,
    selectedRow,
    setSelectedRow,
    selectedCell,
    setSelectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleCellValueChange,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handleMoveRow,
    handlePasteRow,
    setNonWritableFields,
    setPasteConfigs,
    isPasting
  } = useTableRows<BankFeeRow>({
    initialRows: normalizeInitialRows(initialRows),
    defaultField: 'dien_giai',
    onFieldValueChange: (row, field, newValue) => {
      if (field === 'tien_cp_nt' || field === 'ma_cpnh_data') {
        const tien_cp_nt = field === 'tien_cp_nt' ? newValue : row.tien_cp_nt;
        const thue_suat =
          field === 'ma_cpnh_data' ? newValue?.ma_thue_data?.thue_suat : row.ma_cpnh_data?.ma_thue_data?.thue_suat;

        const tienCpNumber = Number(tien_cp_nt) || 0;
        const thueSuatNumber = Number(thue_suat) || 0;

        if (tienCpNumber && thueSuatNumber) {
          return {
            t_thue_nt: (tienCpNumber * thueSuatNumber) / 100,
            thue_suat: thueSuatNumber
          };
        }

        if (thueSuatNumber) {
          return { thue_suat: thueSuatNumber };
        }
      }

      return {};
    }
  });

  return {
    rows,
    setRows,
    selectedRowUuid,
    setSelectedRowUuid,
    selectedRow,
    setSelectedRow,
    selectedCell,
    setSelectedCell,
    handleRowClick,
    handleCellClick,
    clearSelection,
    handleCellValueChange,
    handleAddRow,
    handleDeleteRow,
    handleCopyRow,
    handlePasteRow,
    handleMoveRow,
    setNonWritableFields,
    setPasteConfigs,
    isPasting
  };
}
